module.exports = __webpack_public_path__ + "img/Shop.ba1869ec.svg";